import React, { FC } from 'react'
import { useLottie } from 'lottie-react'
import animation from './animation.json'
import './spinner.css'

// UTILITIES
import { flatten } from '../../../utils/string-helper'


interface Props extends React.HTMLAttributes<HTMLDivElement> {
    indicator?: 'logo' | 'circle'
    type?: 'standard' | 'light'
}

const Spinner: FC<Props> = (props) => {
    const { className: classProps, indicator = 'logo', type = 'standard', ...divProps } = props
    const className = flatten(type, "spinner", classProps)

    const { View } = useLottie({
        animationData: animation,
        loop: true
    })

    if (indicator === 'logo')
        return <div style={{ height: '6rem', width: '6rem' }}>
            {View}
        </div>

    return <div className={className} {...divProps} />
}

export default Spinner
